import hash from 'hash.js'

export { removeHtmlTags } from '@/shared/utils/validate'

export function validateEmail (value) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(value)
}

export const isInputEmpty = (text) => {
  if (!text) {
    return true
  }

  const doc = new DOMParser().parseFromString(text, 'text/html')
  const trimmedText = doc.body.textContent.trim()

  return trimmedText.length === 0
}

export function generateChecksum (data) {
  return hash.sha256().update(data).digest('hex')
}
